// Per-program behaviour for the resource manager (add-resources form): which
// dropdown-options keys back its Level/Year and Council dropdowns, whether
// the Level/Year field applies at all, whether the full Council list shows
// or just "Introduction" (the pre-existing default for any program with no
// real council structure), and which r2/get-presigned-url fetch_key its
// uploads use. Add a program's id here - nothing else in resource-manage.js
// needs touching to onboard it.
const PROGRAM_RESOURCE_CONFIG = {
    4:  {showLevel: true,  levelOptKey: "level_id",     sessionOptKey: "session_id",     sessionMode: "full",      fetchKey: "resource_glosco"}, // Glosco
    8:  {showLevel: true,  levelOptKey: "level_id",     sessionOptKey: "session_id",     sessionMode: "full",      fetchKey: "resource_glosco"}, // GRIP
    9:  {showLevel: false, levelOptKey: null,           sessionOptKey: "session_id",     sessionMode: "introOnly", fetchKey: "resource_ss"},      // Social Startup
    11: {showLevel: true,  levelOptKey: "esg_level_id", sessionOptKey: "esg_session_id", sessionMode: "full",      fetchKey: "resource_esg"},     // ESG Specialist
};

const DEFAULT_PROGRAM_RESOURCE_CONFIG = {
    showLevel: false,
    levelOptKey: null,
    sessionOptKey: "session_id",
    sessionMode: "introOnly",
    fetchKey: "resource_glosco"
};

const getProgramResourceConfig = (programId) => PROGRAM_RESOURCE_CONFIG[programId] || DEFAULT_PROGRAM_RESOURCE_CONFIG;

export {
    PROGRAM_RESOURCE_CONFIG,
    DEFAULT_PROGRAM_RESOURCE_CONFIG,
    getProgramResourceConfig
};
